export const pullOutFrames = [
    {
        name: 'gfb_45',
        height: 0.1,
        width: 0.45,
        depth: 0.1,
        offsets: [ 0, -0.011, -0.005 ],
    },
    {
        name: 'gfb_60',
        height: 0.1,
        width: 0.6,
        depth: 0.1,
        offsets: [ 0, -0.011, -0.005 ],
    },
    {
        name: 'sliding_frame_45',
        height: 0.1,
        width: 0.45,
        depth: 0.1,
        scale: [ 0.99,1,1 ],
    },
    {
        name: 'sliding_frame_60',
        height: 0.1,
        width: 0.6,
        depth: 0.1,
        scale: [ 0.975,1,0.99 ],
        offsets: [ 0, -0.012, -0.002 ],
},
];

export const defaultPullOutFramesOffsets = [ 0, -0.011, -0.005 ] as const;
